import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { bronzeMedal, silverMedal, goldMedal, platinumMedal, ironMedal } from './images/jpg/medalimages';
import '../scss/loyalty-reward-card.component.scss';

interface LoyaltyRewardCardProps {
    medalType: 'Iron' | 'Bronze' | 'Silver' | 'Gold' | 'Platinum';
    level: string;
    description: string;
    pointsRequired: number;
    discount: number;
    isAchieved?: boolean;
}

const getMedalImage = (medalType: 'Iron' | 'Bronze' | 'Silver' | 'Gold' | 'Platinum') => {
    switch (medalType) {
        case 'Iron':
            return ironMedal;
        case 'Bronze':
            return bronzeMedal;
        case 'Silver':
            return silverMedal;
        case 'Gold':
            return goldMedal;
        case 'Platinum':
            return platinumMedal;
        default:
            return bronzeMedal;
    }
};

const getMedalClass = (medalType: 'Iron' | 'Bronze' | 'Silver' | 'Gold' | 'Platinum') => {
    return medalType.toLowerCase();
};

const LoyaltyRewardCard: React.FC<LoyaltyRewardCardProps> = ({
    medalType,
    level,
    description,
    pointsRequired,
    discount,
    isAchieved = false
}) => {
    const { t } = useTranslation();

    const formatPointsDisplay = () => {
        if (pointsRequired === 0) {
            return description;
        }
        const base = t('LOYALTY_PROGRAM_COLLECT_POINTS_TO_RECEIVE_DISCOUNT', {
            points: pointsRequired.toLocaleString(),
            discount: discount
        });
        if (level.includes('Platinum Level') || level.includes('Platinanivå')) {
            return <>{base}<br />{t('EXCLUSIVE_REWARDS')}15,000 SEK</>;
        }
        if (level.includes('Gold Level') || level.includes('Guldnivå')) {
            return <>{base}<br />{t('EXCLUSIVE_REWARDS')}7,500 SEK</>;
        }
        return base;
    };

    return (
        <div className="loyalty-reward-card">
            <div className="medal-icon-container">
                <div className={`medal-icon-wrapper ${getMedalClass(medalType)}`}>
                        {getMedalImage(medalType)} 
                </div>
            </div>
            
            <div className="reward-content">
                <div className="medal-info">
                    <h6 className="medal-title-reward">{level}</h6>
                    <p className="medal-description">
                        {formatPointsDisplay()}
                    </p>
                </div>
                
                {isAchieved && (
                    <div className="achievement-badge">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="check-icon">
                            <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span className="achievement-text">
                            {t('LOYALTY_PROGRAM_MILESTONE_ACHIEVED').toUpperCase()}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LoyaltyRewardCard;
